import React from 'react'

function FlexCardSetting({title, description, isEnabled, handleChange, param}: any) {
    console.log(isEnabled)
  return (
    <div className='px-8 py-8 d-lg-flex justify-content-between'>
      <div className='flex-grow-1  align-items-center justify-content-center w-85'>
        <h5 className='fs-4 fw-bold mb-2'>{title ? title : 'Title Missing ...'}</h5>
        <span className='fs-4'>{description ? description : 'Description is missing .....'}</span>
      </div>

      <div className='flex-grow-0 d-flex align-items-center justify-content-center'>
        <div className='d-flex justify-content-end'>
          <div className='form-check form-check-solid form-switch'>
            <input
              className='form-check-input w-45px h-30px'
              type='checkbox'
              checked={isEnabled}
              onChange={() => handleChange(param, !isEnabled)}
            />
            <label className='form-check-label' htmlFor='githubswitch'></label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FlexCardSetting
